$('.password-visibility-toggle').on('click', function () {
    let passwordInputField = $(this).closest('.form-group').find('input');
    passwordInputField.attr('type') == 'password' ? passwordInputField.attr('type', 'text') : passwordInputField.attr('type', 'password');
    if (passwordInputField.attr('type') == 'text') {
        $(this).find('.icon-visibility').addClass('d-none');
        $(this).find('.icon-not-visible').removeClass('d-none');
    } else {
        $(this).find('.icon-visibility').removeClass('d-none');
        $(this).find('.icon-not-visible').addClass('d-none');
    }
});
